import { useEffect, useMemo, useRef, RefObject } from "react";

export function useScrollToLastSystemMessage(data: any[]) {
  const scrollableDivRef = useRef<HTMLDivElement | null>(null);

  const lastSystemMessageIndex = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return -1;
    }

    return data?.length - 1;

    // for (let idx = data.length - 1; idx >= 0; idx--) {
    //   if (data[idx]?.role === "assistent") {
    //     return idx;
    //   }
    // }

    return -1;
  }, [data]);

  const prevLastSystemMessageIndexRef = useRef<number>(-1);

  useEffect(() => {
    // Only scroll when lastSystemMessageIndex changes to a new value (new system message added)
    if (
      lastSystemMessageIndex !== -1 &&
      lastSystemMessageIndex !== prevLastSystemMessageIndexRef.current
    ) {
      prevLastSystemMessageIndexRef.current = lastSystemMessageIndex;

      // Scroll to bottom when a new system message is added
      if (scrollableDivRef.current) {
        scrollableDivRef.current.scrollTo({
          top: scrollableDivRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    }
  }, [lastSystemMessageIndex]);

  return {
    scrollableDivRef: scrollableDivRef as RefObject<HTMLDivElement>,
    lastSystemMessageIndex,
  };
}
